import { onMounted, onUnmounted } from 'vue';

/** `BaseModal` 등 여러 인스턴스가 겹쳐도 마지막이 닫힐 때까지 배경 스크롤 유지 */
let scrollLockDepth = 0;
let lockedScrollY = 0;

export default function useHoldScroll() {
  const setHold = () => {
    if (scrollLockDepth === 0) {
      lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      const scrollbarW = window.innerWidth - document.documentElement.clientWidth;

      document.body.style.position = 'fixed';
      document.body.style.top = `-${lockedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      if (scrollbarW > 0) {
        document.body.style.paddingRight = `${scrollbarW}px`;
      }
    }
    scrollLockDepth += 1;
  };

  const unsetHold = () => {
    if (scrollLockDepth === 0) return;
    scrollLockDepth -= 1;
    if (scrollLockDepth > 0) return;

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    window.scrollTo(0, lockedScrollY);
  };

  const fetchHoldAction = () => {
    onMounted(() => setHold());
    onUnmounted(() => unsetHold());
  };

  return {
    setHold,
    unsetHold,
    fetchHoldAction,
  };
}
